/**
 * "Incentives" opens Incentyv until incentives are rebuilt (DECISIONS 2026-10-15). The URL is not
 * in the Vinyl export (spec open question 6), so the button is not rendered while this is null.
 * Set it to the URL Zack gives.
 */
export const INCENTIVES_URL: string | null = null;
